module.exports = __webpack_public_path__ + "img/spain-neoplasm-female.644b6a23.png";